import React, { useEffect, useRef } from "react";
import defaultImage from "../assets/img/logo.png";
import useSession from "../hooks/useSession";

const Product = ({product}) => {

	const { isAuthenticated } = useSession();
	const imageRef = useRef(null);

	function addDefaultSrc(e) {
		e.target.src = defaultImage;
	}

	// El `onError` del HTML estático se pierde si la foto falla antes de hidratar
	useEffect(() => {
		const image = imageRef.current;
		if (image && image.complete && image.naturalWidth === 0) image.src = defaultImage;
	}, []);

	return (
		<div className="grid gap-8 lg:grid-cols-2 lg:gap-16">
			<figure className="m-0 flex items-center justify-center border border-line bg-white p-8">
				<img
					ref={ imageRef }
					className="h-auto w-full max-w-md object-contain"
					onError={ addDefaultSrc }
					src={ process.env.GATSBY_WORDPRESS_BASE_URL + "/wp-content/uploads/product-images/" + product.sku + ".jpg" }
					alt={ product.name }
				/>
			</figure>

			<div className="flex flex-col justify-center">
				<p className="meta">Cód. { product.sku }</p>

				<h1 className="mb-6 mt-3.5 text-[32px] font-semibold leading-tight tracking-headline lg:text-[42px]">
					{ product.name }
				</h1>

				{
					product.category &&
						<p className="mb-6 text-sm capitalize text-muted">{ product.category.toLowerCase() }</p>
				}

				{
					isAuthenticated
						? (
							<div className="border-t border-line pt-6 text-3xl font-bold tracking-[-.03em]">
								{ product.price === 0 ? "AGOTADO" : `$ ${product.price}` }
							</div>
						)
						: (
							<p className="border-t border-line pt-6 text-sm text-muted">
								Iniciá sesión con tu usuario de cliente para ver el precio.
							</p>
						)
				}
			</div>
		</div>
	);
};

export default Product;
